import { Tooltip } from '@mantine/core';
import { Badge, variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import { inputContexts } from 'app/modules/wallforming/components/input-binding/registry/inputActionsRegistry';

import type { InputContext } from 'app/modules/wallforming/components/input-binding/types/inputContext';

interface InputContextBadgeProps {
    context: InputContext;
    selected: boolean;
    onSelect: () => void;
}

export const InputContextBadge = ({ context, selected, onSelect }: InputContextBadgeProps) => {
    const { t } = useTranslation();
    const metadata = inputContexts[context];
    const label = t(metadata.labelKey);

    return (
        <Tooltip label={label} position="top">
            <button
                aria-label={label}
                aria-pressed={selected}
                className="shrink-0 cursor-pointer rounded-full font-normal focus-visible:outline-2 focus-visible:outline-border-accent-light disabled:cursor-not-allowed disabled:opacity-50"
                data-testid={`context-badge-${context}`}
                type="button"
                onClick={onSelect}
            >
                <Badge
                    className="cursor-pointer hover:brightness-95"
                    icon={metadata.icon}
                    size="normal"
                    variant={selected ? variants.badge.primaryYellow : variants.badge.neutral}
                >
                    <span data-testid="context-badge-label">{label}</span>
                </Badge>
            </button>
        </Tooltip>
    );
};
